module.exports = __webpack_public_path__ + "img/icon_strategy1.c2229412.d27e0837.svg";